export async function allSettled<TPromises extends Promise<any>[]>(
  promises: TPromises
) {
  return Promise.all(
    promises.map((p) =>
      p
        .then((value) => ({
          status: 'fulfilled',
          value,
        }))
        .catch((reason) => ({
          status: 'rejected',
          reason,
        }))
    )
  )
}
